<div class="auction-gallery" #galleryRoot>
  <div class="auction-swiper2-wrap">
    <swiper #swiperMain [spaceBetween]="8" [loop]="slides.length > 1"
      [autoplay]="{ delay: 3500, disableOnInteraction: false, pauseOnMouseEnter: true }"
      [thumbs]="{ swiper: thumbsSwiper }" (slideChange)="onSlideChange($event)" (swiper)="onMainReady($event)"
      class="auction-swiper2">
      <ng-template swiperSlide *ngFor="let slide of slides; index as i">
        <img [src]="slide" alt="Vehicle image {{ i + 1 }}" loading="lazy" />
      </ng-template>
    </swiper>

    <span class="gallery-counter" *ngIf="slides.length">
      {{ activeIndex + 1 }} / {{ slides.length }}
    </span>

    <button type="button" class="swiper-nav swiper-nav__prev" (click)="slidePrev()" aria-label="Previous image">
      <ion-icon name="caret-back-sharp"></ion-icon>
    </button>
    <button type="button" class="swiper-nav swiper-nav__next" (click)="slideNext()" aria-label="Next image">
      <ion-icon name="caret-forward-sharp"></ion-icon>
    </button>
  </div>

  <div class="swiper-secondary-wrapper">
    <swiper #swiperSecondary (swiper)="thumbsSwiper = $event" [spaceBetween]="8" [slidesPerView]="6" [freeMode]="true"
      [watchSlidesProgress]="true" class="auction-swiper">
      <ng-template swiperSlide *ngFor="let slide of slides; index as i">
        <img [src]="slide" alt="Thumbnail {{ i + 1 }}" (click)="goToSlide(i)" />
      </ng-template>
    </swiper>
  </div>
</div>